import styles from "./Activitygallery.module.scss";
import Link from 'next/link';
import Image from "next/image";
import Slider from "react-slick";
import { useState } from "react";
import Gallerymodal from "../Gallerymodal/Gallerymodal";
import { AncorSecoundaryButton } from "../Buttons/Buttons";

function Activitygallery({ Images, title }) {
    const [clickedImage, setClickedImage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [galleryImages, setGalleryImagees] = useState(Images)

    const settings = {
        infinite: true,
        arrows: true,
        speed: 500,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const handleClick = (item, index) => {
        setCurrentIndex(index);
        setClickedImage(item.image)
    }

    const handleRotationRight = () => {
        const totalLength = galleryImages.length
        if (currentIndex + 1 >= totalLength) {
            setCurrentIndex(0)
            const newUrl = galleryImages[0].image;
            setClickedImage(newUrl)
            return;
        }
        const newIndex = currentIndex + 1;
        const newUrl = galleryImages.filter((item) => {
            return galleryImages.indexOf(item) === newIndex;
        });
        const newItem = newUrl[0].image;
        setClickedImage(newItem)
        setCurrentIndex(newIndex)
    }

    return (
        <>
            <section className={`${styles.gallery_sec}`}>
                <div className="container">
                    <div className="common_title text-center pb-4">
                        <h2>{title ? title : 'Our'} Gallery</h2>
                        {/* <Image src="/icons/line.svg" width={120} height={2} alt='Line Icon'></Image> */}
                    </div>
                    <div className={styles.gallery_main}>
                        <Slider {...settings} className="activity_gallery_slider">
                            {galleryImages.map((item, index) => (
                                <div className={styles.gallery_child} key={index} onClick={() => handleClick(item, index)}>
                                    <img src={item.image} onClick={() => handleClick(item, index)} alt={`Gallery Image ${index + 1}`} />
                                    {/* <Image src={item.image} alt="Gallery Image One" sizes="100%" fill></Image> */}
                                    <div className={styles.gallery_inner}>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                        {clickedImage && (<Gallerymodal clickedImage={clickedImage} handleRotationRight={handleRotationRight} setClickedImage={setClickedImage} />)}
                    </div>
                    <div className='col-md-12 d-flex justify-content-center mt-4'>
                        {/* <Link href='/rides-and-activities' className='common_btn'>Explore All</Link> */}

                        <AncorSecoundaryButton
                            redirectPage={'/rides-and-activities'}
                            className={'margin_0_auto'}
                            buttonText={'Explore All'} />
                    </div>
                </div>
            </section>
        </>
    )
}
export default Activitygallery;